import Translate from '../translate/translate';
import Spinner from '../spinner/spinner';
import { FunctionComponent, h } from 'preact';
import classNames from 'classnames';
import { useTheme } from '../../hooks/use-theme/use-theme';

interface Props {
	disabled: boolean;
	onClick: () => void;
	loading: boolean;
	buttonTranslateText: string;
}

const FooterButton: FunctionComponent<Props> = ({ disabled, onClick, loading, buttonTranslateText }) => {
	const { primaryColor, textColor } = useTheme();

	return (
		<div className="footer-button-container">
			<button
				className={classNames('footer-button', { 'footer-button-disabled': disabled })}
				data-testid="footer-button"
				onClick={onClick}
				disabled={disabled}
				style={!disabled && { backgroundColor: primaryColor, color: textColor }}
			>
				<Translate text={buttonTranslateText} />
				{loading && <Spinner />}
			</button>
		</div>
	);
};

export default FooterButton;
